import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { EditUserPropsTypes } from './EditUserTypes'
import useInputValidate from '../../hooks/useInputValidate'
import InputGroup from '../inputComp/InputGroup'
import { AddressIcon, CloseIcon, CountryIcon, DarkModeIcon, DepartmentIcon, EmailIcon, IconThemeClassic, IdIcon, LightModeIcon, MobileIcon, OrganizationIcon, PasswordIcon, RainbowIcon, RoleIcon, SearchIcon, UserIcon } from '../iconSet/IconSet'
import DragDropUpload from '../inputComp/DragDropUpload'
import { SelectItemTypes } from '../../CommonTypes'
import Container from '../containerComp/Container'
import { InputGroupPropsTypes } from '../inputComp/InputGroupType'
import LoadingScreen from '../loadingScreenComp/LoadingScreen'
import AlertDialog from '../popupComp/AlertDialog'
import OrganizationPolicyDataTable from '../OrganizationAddUserComp/OrganizationPolicyDataTable'
import { AccentColorTypes, ThemeEagleIType, ThemeModesEagleITypes, ThemeModesTypes } from '../settingsComp/SettingsTypes'
import { ThemeTypes } from '../../context/ContextTypes'
import { Department, Organization, Policy, Role, TabTypes, UserType } from '../OrganizationAddUserComp/OrganizationAddUserTypes'
import axios from 'axios'
import { useUserData } from '../../context/UserDataContext'

const accentColorsBCBackoffice: AccentColorTypes[] = [
    {name: 'blue', color: 'rgb(2, 117, 216)'},
    {name: 'green', color: 'rgb(92, 184, 92)'},
    {name: 'cyan', color: 'rgb(91, 192, 222)'},
    {name: 'yellow', color: 'rgb(240, 173, 78)'},
    {name: 'black', color: 'rgb(41, 43, 44)'},
    {name: 'brown', color: 'rgb(196, 64, 64)'}
]

const themeModesBCBackoffice: ThemeModesTypes[] = [
    {name: 'light', icon: <LightModeIcon color='var(--color-text)' width='1.3rem' className='icon'/>},
    {name: 'dark', icon: <DarkModeIcon color='var(--color-text)' width='1rem' className='icon'/>},
    {name: 'colorful', icon: <RainbowIcon color='var(--color-text)' width='1.3rem' className='icon'/>}
]

const accentColorsEagleI: AccentColorTypes[] = [
    {name: 'blue', color: 'rgb(2, 117, 216)'},
    {name: 'green', color: 'rgb(92, 184, 92)'},
    {name: 'cyan', color: 'rgb(91, 192, 222)'},
    {name: 'yellow', color: 'rgb(240, 173, 78)'},
    {name: 'black', color: 'rgb(41, 43, 44)'},
    {name: 'brown', color: 'rgb(196, 64, 64)'}
]

const themeModesEagleI: ThemeModesEagleITypes[] = [
    {name: 'light', icon: <LightModeIcon color='var(--color-text)' width='1.3rem' className='icon'/>},
    {name: 'dark', icon: <DarkModeIcon color='var(--color-text)' width='1rem' className='icon'/>},
    {name: 'classic', icon: <IconThemeClassic color='var(--color-text)' width='1.3rem' className='icon'/>},
    {name: 'darkblue', icon: <RainbowIcon color='var(--color-text)' width='1.3rem' className='icon'/>},
]

const EditUser = (props: EditUserPropsTypes) => {

    const { username } = useUserData()
  
    // Loading screen
        const [isLoading, setIsLoading] = useState<boolean>(false);
    
        const [alertDialogState, setAlertDialogState] = useState(false);
        const [alertTitle, setAlertTitle] = useState('');
        const [alertDescription, setAlertDescription] = useState('');
        const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
        const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK
    
        const showAlertDialog = (
        title: string,
        description: string,
        yesCallback?: () => void,
        okCallback?: () => void
        ) => {
        setAlertTitle(title);
        setAlertDescription(description);
        setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
        setAlertOkCallback(() => okCallback);   // Will trigger only on OK
        setAlertDialogState(true);
        };
    
        //User Details
        const [userDetails, setUserDetails] = useState<any>(null);
    
        // Tabs
        const tabs: string[] = ["basic_details"];
        const [selectedTab, setSelectedTab] = useState<TabTypes>("basic_details");
    
        const [isDataPickerOpen, setIsDataPickerOpen] = useState<boolean>(false);
        const [isRoleSelectOpen, setIsRoleSelectOpen] = useState<boolean>(false);
        const [themeColor, setThemeColor] = useState<String>("");
    
        const allUsers = useRef<UserType[]>([]);
        const [filteredUsersData, setFilteredUserData] = useState<UserType[]>([]);
    
        const [roleData, setRoleData] = useState<SelectItemTypes[]>([]);
    
        const [organizations, setOrganizations] = useState<Organization[]>([]);
        const [departments, setDepartments] = useState<Department[]>([]);
        const [roles, setRoles] = useState<Role[]>([]);
    
        const [selectedOrg, setSelectedOrg] = useState<string>("");
        const [selectedDept, setSelectedDept] = useState<string>("");
    
        const [titleName, setTitleName] = useState<string>("setup user")
        const [getUsername, setUsername] = useState<string>("")
        
    
        const BASE_URL = process.env.REACT_APP_BASE_URL
    
        useEffect(() => {
            const savedUser = sessionStorage.getItem("user");
            if (savedUser) {
                const parsedUser = JSON.parse(savedUser);
                setUserDetails(parsedUser);
    
                // Extract policies from the user data
                const userPolicies = parsedUser.policies
                    .split(",")
                    .map((p: string) => p.trim());
                setUserPolicies(userPolicies); // Add this state to your component
            }
        }, []);
    
        const [userPolicies, setUserPolicies] = useState<string[]>([]);
    
        const hasPolicy = (policyName: string): boolean => {
            return userPolicies.includes(policyName);
        };
    
        useEffect(() => {
            const token = localStorage.getItem("access_token");
            //fetch("https://bos.beconx.live/api/v1/getallorganizations", {
            fetch(BASE_URL + "/identity_manager/api/v1/getallorganizations", {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    //console.log("Fetched organizations JSON:", data);
    
                    const formatted = data.map((org: any) => ({
                        value: org.organizationid,
                        name: org.organizationname,
                    }));
                    setOrganizations(formatted);
                })
                .catch((err) => console.error("Error fetching organizations:", err));
        }, []);
    
        useEffect(() => {
            const token = localStorage.getItem("access_token");
            if (selectedOrg) {
                //fetch(`https://bos.beconx.live/api/v1/getdepartmentsbyorgid?organizationId=${selectedOrg}`,
                fetch(BASE_URL + `/identity_manager/api/v1/getdepartmentsbyorgid?organizationId=${selectedOrg}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                )
                    .then((response) => {
                        if (!response.ok) throw new Error("Failed to load departments");
                        return response.json();
                    })
                    .then((data) => {
                        //console.log("Fetched Departments JSON:", data);
    
                        const formatted = data.map((dep: any) => ({
                            value: dep.departmentid,
                            name: dep.departmentname,
                        }));
                        setDepartments(formatted);
                    })
                    .catch((err) => console.error(err));
                //setSelectedDept("");
            } else {
                setDepartments([]);
            }
        }, [selectedOrg]);
    
        useEffect(() => {
            const token = localStorage.getItem("access_token");
            //fetch(`https://bos.beconx.live/api/v1/getallroles`, {
            fetch(BASE_URL + `/identity_manager/api/v1/getallroles`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    if (!response.ok) throw new Error("Failed to load roles");
                    return response.json();
                })
                .then((data) => {
                    //console.log("Fetched Role JSON:", data);
    
                    const formatted = data.map((role: any) => ({
                        value: role.roleid,
                        name: role.rolename,
                    }));
                    setRoles(formatted);
                })
                .catch((err) => console.error(err));
        }, []);
    
        // Form fields
        const countryRef = useRef<HTMLInputElement | null>(null);
        const usernameRef = useRef<HTMLInputElement | null>(null);
        const firstNameRef = useRef<HTMLInputElement | null>(null);
        const lastNameRef = useRef<HTMLInputElement | null>(null);
        const addressRef = useRef<HTMLInputElement | null>(null);
        const mobileNumberRef = useRef<HTMLInputElement | null>(null);
        const organizationRef = useRef<HTMLSelectElement | null>(null);
        const departmentRef = useRef<HTMLSelectElement | null>(null);
        const roleRef = useRef<HTMLSelectElement | null>(null);
        const emailRef = useRef<HTMLInputElement | null>(null);
        const nicRef = useRef<HTMLInputElement | null>(null);
        const passwordRef = useRef<HTMLInputElement | null>(null);
        const confirmPasswordRef = useRef<HTMLInputElement | null>(null);
    
        // Check box values
        /* const mprMeghaRef = useRef<HTMLInputElement | null>(null);
        const mprVisuraRef = useRef<HTMLInputElement | null>(null);
        const mprVisuraDashboardRef = useRef<HTMLInputElement | null>(null);
        const mprBackOfficeSystemRef = useRef<HTMLInputElement | null>(null); */
    
        const productBconexBackofficeRef = useRef<HTMLInputElement | null>(null);
        const productBconexMobileRef = useRef<HTMLInputElement | null>(null);
        const productEagleIRef = useRef<HTMLInputElement | null>(null);
    
        const [themesBConexBackofficeAvailable, setThemesBConexBackofficeAvailable] = useState<ThemeModesTypes[]>(themeModesBCBackoffice)
        const [themesBConexBackoffice, setThemesBConexBackoffice] = useState<ThemeTypes>('colorful')
        const [accentColorBConexBackofficeAvailable, setAccentColorBConexBackofficeAvailable] = useState<AccentColorTypes[]>(accentColorsBCBackoffice)
        const [accentColorBConexBackoffice, setAccentColorBConexBackoffice] = useState<AccentColorTypes>({name: 'blue', color: 'rgb(2, 117, 216)'})
    
        const [themesEagleIAvailable, setThemesEagleIAvailable] = useState<ThemeModesEagleITypes[]>(themeModesEagleI)
        const [themesEagleI, setThemesEagleI] = useState<ThemeEagleIType>('dark')
        const [accentColorEagleIAvailable, setAccentColorEagleIAvailable] = useState<AccentColorTypes[]>(accentColorsEagleI)
        const [accentColorEagleI, setAccentColorEagleI] = useState<AccentColorTypes>({name: 'blue', color: 'rgb(2, 117, 216)'})
    
        const [file, setFile] = useState<File[]>([])
    
        const [refreshKey, setRefreshKey] = useState(0);
    
        // Policies
        /* const policiesData: Policy[] = [
            { policy: "Policy A", value: "a" },
            { policy: "Policy B", value: "b" },
            { policy: "Policy C", value: "c" },
            { policy: "Policy D", value: "d" },
        ]; */
    
        const [policiesData, setPoliciesData] = useState<Policy[]>([]);
    
        useEffect(() => {
            const fetchPolicies = async () => {
                try {
                    const token = localStorage.getItem("access_token");
                    if (!token) {
                        throw new Error("No authentication token found");
                    }
    
                    //const response = await fetch("https://bos.beconx.live/api/v1/getallpolicies",
                    const response = await fetch(BASE_URL + "/identity_manager/api/v1/getallpolicies",
                        {
                            method: "GET",
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );
    
                    if (!response.ok) {
                        throw new Error(`Failed to fetch policies: ${response.status}`);
                    }
    
                    const data: Policy[] = await response.json();
                    setPoliciesData(data);
                } catch (err) {
                    console.error("Error fetching policies:", err);
                    // Optionally set error state here
                }
            };
    
            fetchPolicies();
        }, []);
    
        const accessPrivileges = [
            /* { label: "megha", ref: mprMeghaRef, value: "megha" },
            { label: "visura", ref: mprVisuraRef, value: "visura" },
            {
                label: "visura dashboard",
                ref: mprVisuraDashboardRef,
                value: "visura_dashboard",
            },
            {
                label: "back office system",
                ref: mprBackOfficeSystemRef,
                value: "back_office_system",
            }, */
            { label: "BConex backoffice", ref: productBconexBackofficeRef, value: "bconex_backoffice" },
            { label: "BConex mobile", ref: productBconexMobileRef, value: "bconex_mobile" },
            { label: "Eagle-I", ref: productEagleIRef, value: "eagle-i" }
        ];
    
        const [form, setForm] = useState<UserType>({
            country: "Sri Lanka",
            username: "",
            firstname: "",
            lastname: "",
            address: "",
            mobilenumber: "",
            organization: "",
            department: "",
            role: "",
            email: "",
            nic: "",
            password: "",
            policies: "",
            accessprivileges: "",
            thememodebconex: "colorful",
            themecolorbconex: "blue",
            thememodeeaglei: "dark",
            //policies: [] as string[],
            specificAreas: []
        });
    
        const policiesCheckboxRef = useRef({
            policies: [] as string[],
        })
        /* const [policiesCheckbox, setPolisciesCheckbox] = useState({
            policies: [] as string[],
        }); */
        const [accessPrivilegesCheckbox, setAccessPrivilegesCheckbox] = useState({
            accessprivileges: [] as string[],
        });
    
        const [isUpdate, setIsUpdate] = useState(false);
    
        const handleChange = (e: any) => {
            const { name, value } = e.target;
    
            console.log(name, value);
    
            // Clone current form state
            let updatedForm = { ...form, [name]: value };
    
            // If organization is changed, reset dependent fields
            if (name === "organization") {
                setSelectedOrg(value);
                updatedForm = {
                    ...updatedForm,
                    department: "", // clear department
                    role: "", // clear role
                };
                setSelectedDept(""); // also reset department state
            }
    
            setForm(updatedForm);
        };
    
        const handleSelectedRowsChange = (selected: Policy[]) => {
            
            const selectedPolicies = selected.map(
                (row: Policy) => row.policy
            );
    
            // Prevent unnecessary state updates
            const isSame =
                selectedPolicies.length === policiesCheckboxRef.current.policies.length &&
                selectedPolicies.every((p: any) => policiesCheckboxRef.current.policies.includes(p));
    
            if (!isSame) {
                policiesCheckboxRef.current = ({ policies: selectedPolicies });
            }
            form.policies = policiesCheckboxRef.current.policies.toString();
        };
    
        const [filterPolicyText, setFilterPolicyText] = useState("");
    
        const filteredPolicies = policiesData.filter((p) =>
            p.policy.toLowerCase().includes(filterPolicyText.toLowerCase())
        );
    
        const columns = [
            {
                name: "Policy Name",
                selector: (row: Policy) => row.policy,
                sortable: true,
            },
        ];
    
        //handleCheckboxChange of Access Privileges
        const handleCheckboxChangeAccessPrivileges = (
            e: React.ChangeEvent<HTMLInputElement>
        ) => {
            const { value, checked } = e.target;
            const updatedAccessPrivileges = checked
                ? [...accessPrivilegesCheckbox.accessprivileges, value]
                : accessPrivilegesCheckbox.accessprivileges.filter((ap) => ap !== value);
    
            setAccessPrivilegesCheckbox({ accessprivileges: updatedAccessPrivileges });
            setForm((prev) => ({
                ...prev,
                accessprivileges: updatedAccessPrivileges.join(","),
            }));
        };
    
        const handleBlur = async () => {
            const token = localStorage.getItem("access_token");
            //const username = JSON.parse(sessionStorage.getItem("userdetails") || "{}").username;
             //const username = usernameRef.current?.value || "";
            //console.log("----form",usernameRef.current?.value);
            const username = form.username?.trim() || "";

            if (!username) return;
    
            //if (usernameRef.current?.value.trim() !== "") {
                try {
                    const res = await axios.get(
                        BASE_URL + `/identity_manager/api/v1/getuser/${username}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
    
                    // ✅ Handle "user not found" response from Spring Boot
                    if (res.data?.status === "not_found") {
                        console.log(res.data.message); // "User not found"
                        setForm({
                            country: "Sri Lanka",
                            username: form.username,
                            firstname: "",
                            lastname: "",
                            address: "",
                            mobilenumber: "",
                            organization: "",
                            department: "",
                            role: "",
                            email: "",
                            nic: "",
                            password: "",
                            policies: "",
                            accessprivileges: "",
                            thememodebconex: "colorful",
                            themecolorbconex: "blue",
                            thememodeeaglei: "dark",
                            specificAreas: []
                        });								
                        policiesCheckboxRef.current = { policies: [] };
                        setAccessPrivilegesCheckbox({ accessprivileges: [] });
                        setIsUpdate(false);
                        return;
                    }
    
                    const fetchedForm = res.data;
    
                    // ✅ Parse policy and privileges
                    const policyArray = fetchedForm.policies
                        ? fetchedForm.policies.split(",").map((p: string) => p.trim())
                        : [];
    
                    const privilegesArray = fetchedForm.accessprivileges
                        ? fetchedForm.accessprivileges.split(",").map((p: string) => p.trim())
                        : [];
    
                    const themeModeBconexValue = fetchedForm.thememodebconex;
                    const themeColorBconexValue = fetchedForm.themecolorbconex;
                    const themeColorEagleIVlaue = fetchedForm.thememodeeaglei;
    
                    const matchedThemeColorBconex = accentColorsEagleI.find(
                        (item) => item.name === themeColorBconexValue
                    );
    
                    setForm({
                        ...fetchedForm,
                    });
                    setSelectedOrg(fetchedForm.organization);
                    policiesCheckboxRef.current = { policies: policyArray };
                    setAccessPrivilegesCheckbox({ accessprivileges: privilegesArray });
    
                    // Theme settings
                    const defaultTheme: ThemeTypes = "dark";
                    setThemesBConexBackoffice((themeModeBconexValue ?? defaultTheme) as ThemeTypes);
                    if (matchedThemeColorBconex) {
                        setAccentColorBConexBackoffice(matchedThemeColorBconex);
                    } else {
                        setAccentColorBConexBackoffice({
                            name: "blue",
                            color: "rgb(2, 117, 216)",
                        });
                    }
                    setThemesEagleI((themeColorEagleIVlaue ?? defaultTheme) as ThemeEagleIType);
    
                    setIsUpdate(true);
                } catch (error: any) {
                    // ✅ Handle admin role rejection (400 Bad Request)
                    if (error.response.data?.message === "Please use another username") {
    
                        showAlertDialog("Username Error","Please use another username",undefined,() => window.location.reload());
                        console.error("Server validation error:");
    
                    } else {
                        console.error("Unexpected error:", error);
                    }
    
                    setForm({
                        country: "Sri Lanka",
                        username: form.username,
                        firstname: "",
                        lastname: "",
                        address: "",
                        mobilenumber: "",
                        organization: "",
                        department: "",
                        role: "",
                        email: "",
                        nic: "",
                        password: "",
                        policies: "",
                        accessprivileges: "",
                        thememodebconex: "colorful",
                        themecolorbconex: "blue",
                        thememodeeaglei: "dark",
                        specificAreas: []
                    });
                    policiesCheckboxRef.current = { policies: [] };
                    setAccessPrivilegesCheckbox({ accessprivileges: [] });
                    setIsUpdate(false);
                }
            //}
        };
    
        useEffect(() => {
            //console.log("Checkbox state updated:", policiesCheckbox.policies);
        }, [policiesCheckboxRef.current, accessPrivilegesCheckbox]);

        // Get username from session storage
        useEffect(() => {
            // const savedUsername = JSON.parse(sessionStorage.getItem("userdetails") || "{}").username;
            // console.log(savedUsername)
            // if (savedUsername) {
            //     setForm(prev => ({ ...prev, username: savedUsername }));
            // }
            setForm(prev => ({ ...prev, username: username }));
        }, [username]);

        // Once username is set, fetch user details
        useEffect(() => {
            if (form.username) {
                handleBlur();
            }
        }, [form.username]);
        
        const formItems: InputGroupPropsTypes[] = [
            {
                type: "text",
                icon: <CountryIcon width="1.5rem" color="var(--color-main-white)" />,
                color: "var(--color-accent-bg)",
                placeholder: "Select country",
                label: "country",
                componentInputElement: countryRef,
                name: "country",
                required: true,
                disabled: true,
                value: "Maldives",
                onChange: handleChange,
            },
            {
                type: "text",
                icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
                color: "var(--color-accent-bg)",
                placeholder: "Enter username",
                label: "username",
                componentInputElement: usernameRef,
                name: "username",
                value: form.username,
                required: true,
                disabled: true,
                onChange: handleChange,
                onBlur: handleBlur,
                //dataPicker: true,
                //isDataPickerOpen: isDataPickerOpen,
                //setIsDataPickerOpen: setIsDataPickerOpen,
            },
            {
                type: "text",
                icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
                color: "var(--color-accent-bg)",
                placeholder: "Enter first name",
                label: "first name",
                name: "firstname",
                value: form.firstname,
                componentInputElement: firstNameRef,
                onChange: handleChange,
            },
            {
                type: "text",
                icon: <UserIcon width="1.5rem" color="var(--color-main-white)" />,
                color: "var(--color-accent-bg)",
                placeholder: "Enter last name",
                label: "last name",
                name: "lastname",
                value: form.lastname,
                componentInputElement: lastNameRef,
                onChange: handleChange,
            },
            {
                type: "text",
                icon: <AddressIcon width="1.5rem" color="var(--color-main-white)" />,
                color: "var(--color-accent-bg)",
                placeholder: "Enter address",
                label: "address",
                name: "address",
                value: form.address,
                componentInputElement: addressRef,
                onChange: handleChange,
            },
            {
                type: "text",
                icon: <MobileIcon width="1.5rem" color="var(--color-main-white)" />,
                color: "var(--color-accent-bg)",
                placeholder: "Enter mobile number",
                label: "mobile number",
                name: "mobilenumber",
                value: form.mobilenumber,
                componentInputElement: mobileNumberRef,
                onChange: handleChange,
            },
            {
                type: "text",
                icon: <EmailIcon width="1.5rem" color="var(--color-main-white)" />,
                color: "var(--color-accent-bg)",
                placeholder: "Enter email",
                label: "email",
                name: "email",
                componentInputElement: emailRef,
                required: true,
                onChange: handleChange,
                value: form.email,
            },
            {
                type: "text",
                icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
                color: "var(--color-accent-bg)",
                placeholder: "Enter NIC number",
                label: "NIC number",
                name: "nic",
                componentInputElement: nicRef,
                value: form.nic,
                //required: true,
                onChange: handleChange,
            },
        ];
    
        const handleAddUser = async () => {
            setIsLoading(true)
            const token = localStorage.getItem("access_token");
            //const response = await fetch("https://bos.beconx.live/api/v1/administratoradduser",
            const response = await fetch(BASE_URL + "/identity_manager/api/v1/bconexadduser",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(form),
                }
            );
    
            if (response.ok) {
                const data = await response.json();
                if (data.message === "User Already Exits") {
                    showAlertDialog("User Exists", "User already exists! user was not added.");
                    //alert("User Already Exits! : User Not Added");
                } else if (data.message === "Email Already Exits") {
                    //alert("Email Already Exits! : User Not Added");
                    showAlertDialog("Email Exists", "Email already exists! user was not added.");
                } else {
                    showAlertDialog(isUpdate ? "Success" : "Created", isUpdate ? "✅ Profile updated successfully!" : "User created.", undefined, () => window.location.reload());
                    setForm({
                        country: "Sri Lanka",
                        username: "",
                        firstname: "",
                        lastname: "",
                        address: "",
                        mobilenumber: "",
                        organization: "",
                        department: "",
                        role: "",
                        email: "",
                        nic: "",
                        password: "",
                        policies: "",
                        accessprivileges: "",
                        thememodebconex: "colorful",
                        themecolorbconex: "blue",
                        thememodeeaglei: "dark",
                        specificAreas: []
                    });
                    policiesCheckboxRef.current = ({ policies: [] });
                    setAccessPrivilegesCheckbox({ accessprivileges: [] });
                    setIsUpdate(false);
                    setRefreshKey((prev) => prev + 1);
                }
                //console.log("User added successfully!", data.message);
            } else {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    const err = await response.json();
                    console.log("User adding failed: " + err.message);
                } else {
                    const errText = await response.text(); // handle plain text response
                    console.log("User adding failed: " + errText);
                }
            }
            setIsLoading(false)
        };
    
        const handleDeleteUser = async () => {
            const token = localStorage.getItem("access_token");
            if (!token) {
                showAlertDialog("Unauthorized", "Missing access token.");
                return;
            }
    
            try {
                //const response = await fetch(`https://bos.beconx.live/api/v1/delete/${form.username}`,
                const response = await fetch(BASE_URL + `/identity_manager/api/v1/delete/${form.username}`,
                    {
                        method: "DELETE",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
    
                if (response.ok) {
                    const resultText = await response.text(); // assuming plain string response like "User deleted successfully"
                    showAlertDialog("Deleted", resultText,undefined,() => window.location.reload())
                    setForm({
                        country: "Sri Lanka",
                        username: "",
                        firstname: "",
                        lastname: "",
                        address: "",
                        mobilenumber: "",
                        organization: "",
                        department: "",
                        role: "",
                        email: "",
                        nic: "",
                        password: "",
                        policies: "",
                        accessprivileges: "",
                        thememodebconex: "colorful",
                        themecolorbconex: "blue",
                        thememodeeaglei: "dark",
                        specificAreas: []
                    });
                    policiesCheckboxRef.current = ({ policies: [] });
                    setAccessPrivilegesCheckbox({ accessprivileges: [] });
                    setIsUpdate(false);
                } else {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.includes("application/json")) {
                        const error = await response.json();
                        console.log(error.message || "Error deleting user");
                    } else {
                        const errorText = await response.text();
                        console.log(errorText);
                    }
                }
            } catch (err) {
                console.error("Delete failed", err);
                console.log("An error occurred during deletion");
            }
        };
    
        // Handle create user next button click
        const handleCreateUserNextClick = () => {
            //const country = validateField(countryRef);
            //const username = validateField(usernameRef);
            // const nic = validateField(nicNumberRef);
            const password = passwordRef.current?.value;
            const confirmPassword = confirmPasswordRef.current?.value;
            //console.log(password)
            //console.log(confirmPassword)
            if (password != confirmPassword) {
                showAlertDialog("Validation Error", "Passwords do not match!");
                return;
            }
            console.log(password);
            console.log(confirmPassword);
            //handleAddUser();
            //if (country && username && nic) {
            setSelectedTab("policies");
            //}
        };
    
        // Handle tab click
        const handleTabClick = (tab: string) => {
            setSelectedTab(tab as TabTypes)
        };
    
        // Handle polices back button click
        const handlePoliceBackClick = () => {
            setSelectedTab("basic_details");
        };
    
        // Handle polices finish button click
        const handleEditProfile = () => {
            handleAddUser();
        };
    
        useEffect(() => {
            if (countryRef.current && usernameRef.current) {
                countryRef.current.value = "Maldives";
                //usernameRef.current.value = 'user_1'
            }
            setForm((prevForm) => ({
                ...prevForm,
                country: "Maldives",
            }));
        }, []);
    
        // existing data change handle
        const handleChangeExistingDataSearch = (
            event: ChangeEvent<HTMLInputElement>
        ): void => {
            if (event.target.value === "") {
                setFilteredUserData(allUsers.current);
            } else {
                setFilteredUserData(
                    allUsers.current.filter((item) =>
                        item.username
                            .toLowerCase()
                            .startsWith(event.target.value.toLowerCase())
                    )
                );
            }
        };
    
        // Get all available organization
        const getAllUsers = () => {
            const token = localStorage.getItem("access_token");
            //fetch("https://bos.beconx.live/api/v1/getallusers", {
            fetch(BASE_URL + "/identity_manager/api/v1/getallusers", {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    allUsers.current = data;
                    setFilteredUserData(data);
                })
                .catch((err) => console.error("Error fetching roles:", err));
        };
    
        // Load data
        useEffect(() => {
            setIsLoading(true);
            getAllUsers();
            setIsLoading(false);
        }, [isUpdate, refreshKey]);
    
        // Calculate field count
        const sideFieldCount = (totalField: number): number => {
            if (totalField > 0) {
                const value = totalField % 2
    
                if (value === 0){
                    return totalField / 2
                } else {
                    return (totalField + 1) /2
                }
            } else {
                return totalField
            }
        }
    
        return (
            <div className={`container-wrapper`}>
                <span className={`title`}>Edit Profile</span>
                <div className="tab-area">
                    {tabs.map((tab, index) => (
                        <span key={index} style={{ borderStyle: selectedTab === tab ? "solid" : "none" }} onClick={() => handleTabClick(tab)}>
                            {tab.replace(/_/g, " ")}
                        </span>
                    ))}
                </div>
                {/* Back office system -> add user -> create user */}
                <div style={{ display: selectedTab === "basic_details" ? "block" : "none", width: "100%", height: "100%" }}>
                    <div className={`add-organization-user`}>
                        <div className={`grid-layout-add-organization-user`}>
                            <div className={`left-side`}>
                                {formItems.slice(0, sideFieldCount(formItems.length)).map((field, index) => (
                                    isUpdate ? (
                                        (field.name === 'password' || field.name === 'confirm_password') ? (
                                            <InputGroup key={index} {...{...field, notVisible: true}} />
                                        ) : <InputGroup key={index} {...field} />
                                    ) : (
                                        <InputGroup key={index} {...field} />
                                    )
                                ))}
                            </div>
    
                            <div className={`right-side`}>
                                {formItems.slice(sideFieldCount(formItems.length)).map((field, index) => (
                                    isUpdate ? (
                                        (field.name === 'password' || field.name === 'confirm_password') ? (
                                            <InputGroup key={index} {...{...field, notVisible: true}} />
                                        ) : <InputGroup key={index} {...field} />
                                    ) : (
                                        <InputGroup key={index} {...field} />
                                    )
                                ))}
                            </div>
    
                            {/* <div className={`checkbox-wrapper`}>
                                <div className={`checkbox-container`}>
                                    <span className={`title`}>products</span>
                                    <div className={"wrapper"}>
                                        {accessPrivileges.map((priv, index) => (
                                            <div key={index} className="item">
                                                <input
                                                    type="checkbox"
                                                    name="accessprivileges"
                                                    id={`ur_checkbox_${priv.value}`}
                                                    ref={priv.ref}
                                                    value={priv.value}
                                                    checked={accessPrivilegesCheckbox.accessprivileges.includes(
                                                        priv.value
                                                    )}
                                                    onChange={handleCheckboxChangeAccessPrivileges}
                                                />
                                                <label htmlFor={`ur_checkbox_${priv.value}`}>
                                                    {priv.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div> */}
    
                            <div className={`button-wrapper`} style={{ gridArea: "button" }}>
                                <div className={`left-side`}></div>
                                <div className={`right-side`}>
                                    <button className={`button-normal`} onClick={(e) => {
                                        showAlertDialog(
                                            "Confirm Submit",
                                            "Are you sure you want to submit this profile changes?",
                                            () => handleEditProfile(), undefined)
                                    }}>edit profile</button>
                                </div>
                            </div>
                            {/* {isDataPickerOpen && (
                                <div className="data-picker-table-wrapper">
                                    <div className="data-picker-table-container">
                                        <div className="search-wrapper">
                                            <input
                                                type="text"
                                                placeholder="Search Organization by Id"
                                                onChange={(e) => handleChangeExistingDataSearch(e)}
                                            />
                                            <div className="search-icon">
                                                <SearchIcon
                                                    width="1rem"
                                                    color="var(--color-main-white)"
                                                />
                                            </div>
                                            <div
                                                className="close-icon"
                                                onClick={(e) => setIsDataPickerOpen(false)}
                                            >
                                                <CloseIcon width="1.5rem" color="var(--color-text)" />
                                            </div>
                                        </div>
                                        <div className="data-wrapper">
                                            {filteredUsersData.map((user, index) => (
                                                <div
                                                    key={index}
                                                    className="row"
                                                    onClick={(e) => handleClickFilteredOrganization(user)}
                                                >
                                                    <span>{user.country}</span>
                                                    <span>{user.username}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )} */}
    
                            {/* {isRoleSelectOpen && (
                            <div className="data-picker-table-wrapper">
                                <div className="data-picker-table-container">
                                    <span className="role-title">select roles <div onClick={(e) => setIsRoleSelectOpen(false)}><CloseIcon width="1rem" color="var(--color-text)"/></div></span>
                                    <div className="role-data-wrapper">
                                        {selectRole.map((data, index) => (
                                            <div key={index} className="role-data-check-container">
                                                <input type="checkbox" name={data.value} id="bo-add-user-role-1" onChange={(e) => handleChangeRoleSelect(e)}/>
                                                <label htmlFor="bo-add-user-role-1">{data.name}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )} */}
                        </div>
                    </div>
                </div>
    
                {/* Back office system -> add user -> profile */}
                
    
                {/* Back office system -> add user -> polices */}
                {/* <div style={{ display: selectedTab === "policies" ? "block" : "none", width: "100%", height: "100%" }}>
                    <div className={`add-organization-user`}>
                        <div className={`grid-layout-polices`}>
                            <div className="policy-table-container">
                                <OrganizationPolicyDataTable data={filteredPolicies} handleSelectRow={handleSelectedRowsChange} selectedPolicies={policiesCheckboxRef.current.policies}/>
                            </div>
                        </div>
                        <div className={`button-wrapper`} style={{ gridArea: "button" }}>
                            <div className={`left-side`}>
                                <button className={`button-normal`} onClick={(e) => setSelectedTab('themes')}>back</button>
                            </div>
                            <div className={`right-side`}>
                                <button className={`button-normal`} onClick={(e) => handlePolicesFinishClick()}>
                                    {isUpdate ? "Update" : "Add"}
                                </button>
                                {isUpdate && (
                                    <button className={`button-normal`} onClick={(e) =>
                                        showAlertDialog(
                                            "Confirm Delete",
                                            "Are you sure you want to delete this user?",
                                            handleDeleteUser,
                                            undefined
                                        ) 
                                    }>Delete</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div> */}
                {isLoading ? <LoadingScreen /> : null}
                {alertDialogState && (
                    <AlertDialog
                        title={alertTitle}
                        description={alertDescription}
                        windowState={alertDialogState}
                        setWindowState={setAlertDialogState}
                        function={alertYesCallback}
                        okFunction={alertOkCallback}
                    />
                )}
            </div>
        );
}

export default EditUser